import React from 'react';
import MainPrivacyPolicy from '../../components/Main/MainPolicy/MainPrivacyPolicy';

export default function PrivacyPolicy(){
    return(
        <div>
           <MainPrivacyPolicy />
        </div>
    )
}
